import { siteName } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[-120px] right-[-80px] w-[500px] h-[500px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute bottom-[-100px] left-[-60px] w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-20">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-semibold mb-5">
              <i className="ri-fire-fill text-sm"></i>
              <span>今日更新 28 部</span>
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              {siteName}
              <span className="block text-foreground-700 font-body text-base sm:text-lg md:text-xl font-normal mt-2">
                聚合高清影视 · 免费在线观看
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-[600px] lg:max-w-none">
              妖精视频免费在线平台，聚合西瓜视频免费、91视频网站等高清影视资源，无需下载不缓冲即点即播。
              每日同步更新热播电视剧全集与最新电影大片，覆盖古装、悬疑、韩剧、国漫等全品类内容，
              为追剧爱好者和电影迷提供纯净流畅的一站式观影体验。
            </p>

            <div className="flex flex-wrap items-center gap-5 justify-center lg:justify-start mb-8">
              <div className="flex items-center gap-1.5">
                <div className="w-2 h-2 rounded-full bg-green-500"></div>
                <span className="text-xs text-foreground-500">在线线路 12 条</span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                <span className="text-xs text-foreground-500">今日新增 28 部</span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                <span className="text-xs text-foreground-500">累计资源 5,200+</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看热播榜单
              </a>
              <a
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-timer-line"></i>
                最新更新动态
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20screen%20displaying%20colorful%20movie%20scenes%20comfortable%20sofa%20soft%20ambient%20lighting%20warm%20cozy%20atmosphere%20cinematic%20entertainment%20room%20with%20posters%20on%20wall%20rich%20dark%20wood%20and%20warm%20gold%20accents&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="妖精视频高清观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="h-1.5 bg-background-50/30 rounded-full overflow-hidden">
                    <div className="h-full w-[65%] bg-primary-500 rounded-full"></div>
                  </div>
                </div>
                <span className="text-background-50 text-xs whitespace-nowrap">42:18</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}